export const MaxWidth = {
	'3xs': 'max-w-3xs',
	'2xs': 'max-w-2xs',
	xs: 'max-w-xs',
	sm: 'max-w-sm',
	md: 'max-w-md',
	lg: 'max-w-lg',
	xl: 'max-w-xl',
	'2xl': 'max-w-2xl',
	'3xl': 'max-w-3xl',
	'4xl': 'max-w-4xl',
	'5xl': 'max-w-5xl',
	'6xl': 'max-w-6xl',
	'7xl': 'max-w-7xl',
} as const;


export const WIDTH = {
	fit: 'w-fit',
	full: 'w-full',
	'200%': 'w-[200%]',
	0: 'w-0',
	1: 'w-1', // 0.25 rem (4px)
	5: 'w-5',
	7: 'w-7',
} as const;

export type Width = keyof typeof WIDTH;


export const WIDTH_TABLET = {
	fit: 'tablet:w-fit',
	full: 'tablet:w-full',
	'200%': 'tablet:w-[200%]',
	'340px': 'tablet:w-[340px]', // Used in FileUpload.
} as const;

export type WidthTablet = keyof typeof WIDTH_TABLET;
